export const AMOUNT = "amount";
export const INVESTMENT_AMOUNT = "investment_amount";
export const FINANCING_AMOUNT = "financing_amount";
export const INFORMATION_ON_GRANTS = "information_on_grants";
export const REMARK = "remark";

/**
 *  Affirmations
 */

export const IS_ALREADY_SELF_EMPLOYED = "is_already_self_employed";
export const IS_BANKRUPT = "is_bankrupt";
export const IS_SME = "is_sme";
export const HAS_SHARES_IN_OTHER_COMPANY = "has_shares_in_other_company";

/**
 *  Company / Finanzierungsvorhaben
 */

export const COMPANY__ROLE = "company_role";
export const COMPANY__NAME = "name";
export const COMPANY__ZIP_CODE = "zip_code";
export const COMPANY__CITY = "city";
export const COMPANY__STREET = "street";
export const COMPANY__LOCATION = "location";
export const COMPANY__LEGAL_FORM = "legal_form";
export const COMPANY__TURNOVER_CLASS = "turnover_class";
export const COMPANY__FOUNDING_YEAR = "founding_year";
export const COMPANY__FOUNDING_DATE = "founding_date";
export const COMPANY__NEGATIVE_EQUITY = "negative_equity_capital";
export const COMPANY__INNOVATIVE = "innovative_company";
export const COMPANY__ENERGY_EFFICIENT = "energy_efficient";
export const COMPANY__CONSIDER_SUBSIDY = "consider_subsidies";
export const COMPANY_ROLE__FOUNDER = "founder";
export const COMPANY_ROLE__SUCCESSOR = "successor";
export const COMPANY_ROLE__ESTABLISHED_ENTREPRENEUR = "established_enterpriser";
export const COMPANY_ROLE__OKP_ESTABLISHED_ENTREPRENEUR = "established_entrepreneur";

export const COMPANY__CONTACT_PERSON = "contact_person";
export const COMPANY__CONTACT_PERSON_COMPANY__ROLE = "position";
export const COMPANY__CONTACT_PERSON_EMAIL = "email";
export const COMPANY__CONTACT_PERSON_NAME = "contact_person_name";
export const COMPANY__CONTACT_PERSON_PHONE_NUMBER = "phone_number";
export const COMPANY__CONTACT_PERSON_GENDER = "gender";
export const COMPANY__CONTACT_PERSON_FIRST_NAME = "first_name";
export const COMPANY__CONTACT_PERSON_LAST_NAME = "last_name";
export const COMPANY__CONTACT_PERSON_PRIVACY_POLICY = "privacy_policy";
export const COMPANY__CONTACT_PERSON_COMMUNICATION_ONLY_VIA_BANK_ADVISOR =
  "communication_only_via_bank_advisor";

export const COMPANY_CONTACT_PERSON_COMPANY_ROLE__COMPANY_OWNER = "company_owner";
export const COMPANY_CONTACT_PERSON_COMPANY_ROLE__ASSOCIATE = "associate";
export const COMPANY_CONTACT_PERSON_COMPANY_ROLE__MANAGING_DIRECTOR = "managing_director";
export const COMPANY_CONTACT_PERSON_COMPANY_ROLE__STAFF = "staff";
export const COMPANY_CONTACT_PERSON_COMPANY_ROLE__AUTHORIZED_SIGNATORY = "authorized_signatory";
export const COMPANY_CONTACT_PERSON_COMPANY_ROLE__BOARD = "board";
export const COMPANY_CONTACT_PERSON_COMPANY_ROLE__OTHER = "other";

export const COMPANY__TURNOVER_CLASS__0_TO_10_THOUSAND = "0_to_10_thousand";
export const COMPANY__TURNOVER_CLASS__10_TO_20_THOUSAND = "10_to_20_thousand";
export const COMPANY__TURNOVER_CLASS__20_TO_30_THOUSAND = "20_to_30_thousand";
export const COMPANY__TURNOVER_CLASS__30_TO_40_THOUSAND = "30_to_40_thousand";
export const COMPANY__TURNOVER_CLASS__40_TO_50_THOUSAND = "40_to_50_thousand";
export const COMPANY__TURNOVER_CLASS__50_TO_75_THOUSAND = "50_to_75_thousand";
export const COMPANY__TURNOVER_CLASS__75_TO_100_THOUSAND = "75_to_100_thousand";
export const COMPANY__TURNOVER_CLASS__100_TO_250_THOUSAND = "100_to_250_thousand";
export const COMPANY__TURNOVER_CLASS__250_TO_500_THOUSAND = "250_to_500_thousand";
export const COMPANY__TURNOVER_CLASS__500_THOUSAND_TO_1_MILLION = "500_thousand_to_1_million";
export const COMPANY__TURNOVER_CLASS__1_MILLION_TO_2_5_MILLION = "1_million_to_2_5_million";
export const COMPANY__TURNOVER_CLASS__2_5_TO_5_MILLION = "2_5_to_5_million";
export const COMPANY__TURNOVER_CLASS__5_TO_10_MILLION = "5_to_10_million";
export const COMPANY__TURNOVER_CLASS__10_TO_25_MILLION = "10_to_25_million";
export const COMPANY__TURNOVER_CLASS__25_TO_50_MILLION = "25_to_50_million";
export const COMPANY__TURNOVER_CLASS__50_TO_100_MILLION = "50_to_100_million";
export const COMPANY__TURNOVER_CLASS__MORE_THAN_100_MILLION = "more_than_100_million";

export const COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS = "annual_net_profit_or_loss_class";
export const COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__LOSS = "loss";
export const COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__ZERO = "zero";
export const COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__1_TO_10_THOUSAND = "1_to_10_thousand";
export const COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__10_TO_20_THOUSAND = "10_to_20_thousand";
export const COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__20_TO_30_THOUSAND = "20_to_30_thousand";
export const COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__30_TO_40_THOUSAND = "30_to_40_thousand";
export const COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__40_TO_50_THOUSAND = "40_to_50_thousand";
export const COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__50_TO_75_THOUSAND = "50_to_75_thousand";
export const COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__75_TO_100_THOUSAND = "75_to_100_thousand";
export const COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__100_TO_250_THOUSAND = "100_to_250_thousand";
export const COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__250_TO_500_THOUSAND = "250_to_500_thousand";
export const COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__500_TO_750_THOUSAND = "500_to_750_thousand";
export const COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__500_THOUSAND_TO_1_MILLION =
  "500_thousand_to_1_million";
export const COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__750_THOUSAND_TO_1_MILLION =
  "750_thousand_to_1_million";
export const COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__1_TO_2_5_MILLION = "1_to_2_5_million";
export const COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__1_MILLION_TO_2_5_MILLION =
  "1_million_to_2_5_million";
export const COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__2_5_TO_5_MILLION = "2_5_to_5_million";
export const COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__5_TO_10_MILLION = "5_to_10_million";
export const COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__10_TO_25_MILLION = "10_to_25_million";
export const COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__25_TO_50_MILLION = "25_to_50_million";
export const COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__10_TO_50_MILLION = "10_to_50_million";
export const COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__50_TO_100_MILLION = "50_to_100_million";
export const COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__MORE_THAN_50_MILLION =
  "more_than_50_million";
export const COMPANY__ANNUAL_NET_PROFIT_OR_LOSS_CLASS__MORE_THAN_100_MILLION =
  "more_than_100_million";

export const COMPANY__INDUSTRY = "industry";
export const COMPANY__INDUSTRY_CONSTRUCTION = "construction";
export const COMPANY__INDUSTRY_MINING = "mining";
export const COMPANY__INDUSTRY_PROVISION_SERVICES = "provision_services";
export const COMPANY__INDUSTRY_FINANCIAL_AND_INSURANCE = "financial_and_insurance";
export const COMPANY__INDUSTRY_HOSPITALITY = "hospitality";
export const COMPANY__INDUSTRY_HEALTH_AND_SOCIAL = "health_and_social";
export const COMPANY__INDUSTRY_TRADE = "trade";
export const COMPANY__INDUSTRY_HANDICRAFT = "handicraft";
export const COMPANY__INDUSTRY_REAL_ESTATE = "real_estate";
export const COMPANY__INDUSTRY_INFORMATION_AND_COMMUNICATION = "information_and_communication";
export const COMPANY__INDUSTRY_AGRICULTURE_AND_FORESTRY = "agriculture_and_forestry";
export const COMPANY__INDUSTRY_NANUFACTURING = "manufacturing";
export const COMPANY__INDUSTRY_OTHER = "other";
export const COMPANY__INDUSTRY_PROCESSING = "processing";
export const COMPANY__INDUSTRY_TRANSPORT_AND_LOGISTICS = "transport_and_logistics";

/**
 *  Purpose role
 */

export const PURPOSE_KIND = "purpose_kind";
export const PURPOSE_KIND__REAL_ESTATE = "real_estate";
export const PURPOSE_KIND__LIQUIDITY = "liquidity";
export const PURPOSE_KIND__GOODS = "goods";
export const PURPOSE_KIND__COMMERCIAL_VEHICLE = "vehicles";
export const PURPOSE_KIND__EQUIPMENT = "equipment";
export const PURPOSE_KIND__MACHINERY_AND_TECHNICAL_PLANT = "machine";
export const PURPOSE_KIND__HARD_SOFTWARE = "hard_and_software";
export const PURPOSE_KIND__DEVELOPMENT_EXPENDITURE = "development_expenditure";
export const PURPOSE_KIND__CORONA = "corona";
export const PURPOSE_KIND__FINANCE_CHECK = "finance_check";
export const PURPOSE_KIND__GUARANTEED_CREDIT = "guaranteed_credit";
export const PURPOSE_KIND__ADDITIONAL_COSTS = "additional_costs";
export const PURPOSE_KIND__CONSTRUCTION_INVESTMENT = "construction_investment";
export const PURPOSE_KIND__INVESTMENT_RESERVE = "investment_reserve";
export const PURPOSE_KIND__LICENSES_INTANGIBLE_ASSETS = "licenses_intangible_assets";
export const PURPOSE_KIND__MARKET_ENTRY = "market_entry";
export const PURPOSE_KIND__PARTICIPATION = "participation";
export const PURPOSE_KIND__PREOPERATIONAL_COSTS = "pre_operational_costs";
export const PURPOSE_KIND__PURCHASE_OR_ACQUISITION_PRICE = "purchase_or_acquisition_price";
export const PURPOSE_KIND__OTHER = "other";

/**
 *  Real estate
 */

export const REAL_ESTATE_PROJECT = "real_estate_project";
export const REAL_ESTATE__NEW_BUILDING = "new_building";
export const REAL_ESTATE__PURCHASE = "purchase";
export const REAL_ESTATE__RECONSTRUCTION = "reconstruction";

/**
 * Project
 */

export const PROJECT_START = "project_start";

/**
 * New building
 */

export const REAL_ESTATE_KIND = "real_estate_kind";

export const REAL_ESTATE_KIND__BUSINESS_BUILDING = "business_building";
export const REAL_ESTATE_KIND__HOTEL = "hotel";
export const REAL_ESTATE_KIND__OFFICE_BUILDING = "office_building";
export const REAL_ESTATE_KIND__OTHER = "other";
export const REAL_ESTATE_KIND__RESIDENCE = "residence";
export const REAL_ESTATE_KIND__SPECIALTY_SHOPPING_CENTER = "specialty_shopping_center";
export const REAL_ESTATE_KIND__WAREHOUSE = "warehouse_or_production_hall";

export const REAL_ESTATE_SCHEDULED_DATE = "real_estate_scheduled_date";

export const REAL_ESTATE_RESIDUAL_PERCENTAGE = "real_estate_residual_percentage";

// TODO just a helper, set 'none' for REAL_ESTATE_KFW_STANDARRD if false
export const REAL_ESTATE_IS_KFW_HELPER = "real_estate_eligible_project";

export const REAL_ESTATE_KFW_STANDARD = "real_estate_kfw_standard";
export const REAL_ESTATE_KFW_STANDARD__40_PLUS = "40_plus";
export const REAL_ESTATE_KFW_STANDARD__40 = "40";
export const REAL_ESTATE_KFW_STANDARD__55 = "55";

/**
 *  Building details
 */

export const BUILDING_DETAILS_SECTION_ID = "building_details"; // NOT USED

export const REAL_ESTATE_USAGE_SIZE = "real_estate_usage_size";

export const REAL_ESTATE_BUILDING_SIZE = "real_estate_building_size";

export const REAL_ESTATE_HERITABLE_BUILDING_RIGHT = "real_estate_heritable_building_right";

export const REAL_ESTATE_HERITABLE_BUILDING_RIGHT_OBLIGATION =
  "real_estate_heritable_building_right_obligation";

export const REAL_ESTATE_USAGE_KIND = "real_estate_usage_kind";
export const USE_TYPE__OWN_USE = "own_use";
export const USE_TYPE__THIRD_PARTY_RENTAL = "third_party_rental";
export const USE_TYPE__BOTH = "both";
export const USE_TYPE__OTHER = "other";

export const REAL_ESTATE_RENTED_OUT_AREA = "real_estate_rented_out_area";

export const REAL_ESTATE_COLD_RENT = "real_estate_cold_rent";

export const REAL_ESTATE_TAXATION = "real_estate_taxation";
export const REAL_ESTATE__NETTO = "net";
export const REAL_ESTATE__BRUTTO = "gross";

export const REAL_ESTATE_ZIP_CODE = "real_estate_zip_code";

/**
 * Purchase
 */

export const PURCHASE_SECTION_ID = "purchase";
export const REAL_ESTATE_PURCHASE_PRICE = "real_estate_purchase_price";
export const REAL_ESTATE_CONSTRUCTION_YEAR = "real_estate_construction_date";

/**
 *  Federal state
 */

export const FEDERAL_STATE = "federal_state";

/**
 * Financing needs
 */

export const FINANCING_NEEDS = "financing_needs";
export const PURPOSE_KIND_VALUE = "value";
export const PURPOSE_KIND_KIND = "kind";
export const PURPOSE_KIND_DESCRIPTION = "purpose_kind_description";

// Financing Check (Details exposure)
export const FINANCE_CHECK_IHK_TALK = "finance_check_ihk_talk";
export const FINANCE_CHECK_IHK = "finance_check_ihk_instance";
export const FINANCE_CHECK_IHK_CONSULTANT = "finance_check_ihk_consultant";
export const FINANCE_CHECK_INFORMATION_SHEET = "finance_check_information_sheet";

/**
 *  Goods
 */

export const GOODS_PURCHASE_PRICE = "goods_purchase_price";
export const GOODS_DESCRIPTION = "goods_description";
export const GOODS_SUPPLIER = "goods_supplier";
export const GOODS_ESTIMATED_DELIVERY_DATE = "goods_estimated_delivery_date";

/**
 * Liquidity
 */

export const LIQUIDITY_DESCRIPTION = "liquidity_description";
export const LIQUIDITY_ESTIMATED_DELIVERY_DATE = "liquidity_estimated_delivery_date";

/**
 * Equipment
 */

export const EQUIPMENT_PURCHASE_PRICE = "equipment_purchase_price";
export const EQUIPMENT_DESCRIPTION = "equipment_description";
export const EQUIPMENT_SUPPLIER = "equipment_supplier";
export const EQUIPMENT_ESTIMATED_DELIVERY_DATE = "equipment_estimated_delivery_date";

/**
 *  Vehicle
 */

export const VEHICLE_NEW = "vehicle_new";
export const VEHICLE_COUNT = "vehicle_count";
export const VEHICLE_KIND = "vehicle_kind";
export const VEHICLE_KIND__CAR = "car";
export const VEHICLE_KIND__UTILITY_VEHICLE = "utility_vehicle";
export const VEHICLE_KIND__OTHER = "other";
export const VEHICLE_OTHER_DESCRIPTION = "vehicle_other_description";
export const VEHICLE_MANUFACTURER = "vehicle_manufacturer";
export const VEHICLE_MODEL = "vehicle_model";
export const VEHICLE_YEARLY_MILEAGE = "vehicle_yearly_mileage";
export const VEHICLE_YEAR = "vehicle_year";

/**
 *  Hardware software
 */

export const SOFTWARE_DESCRIPTION = "software_description";
export const SOFTWARE_PERIOD_OF_USE = "software_period_of_use";
export const SOFTWARE_MANUFACTURER = "software_manufacturer";

/**
 *  Machine
 */

export const MACHINE_PRICE = "machine_price";
export const MACHINE_CATEGORY = "machine_category";
export const MACHINE_CATEGORY__METAL = "metal";
export const MACHINE_CATEGORY__WOOD = "wood";
export const MACHINE_CATEGORY__PLASTIC = "plastic";
export const MACHINE_CATEGORY__TOOL = "tool";
export const MACHINE_CATEGORY__PRINT = "print";
export const MACHINE_CATEGORY__CONSTRUCTION = "construction";
export const MACHINE_CATEGORY__HEALTH = "health";
export const MACHINE_CATEGORY__ENERGY = "energy";
export const MACHINE_CATEGORY__RENEWABLE_ENERGY = "renewable_energy";
export const MACHINE_CATEGORY__FOOD = "food";
export const MACHINE_CATEGORY__LOGISTIC = "logistic";
export const MACHINE_CATEGORY__PACKAGING = "packaging";
export const MACHINE_CATEGORY__RECYCLING = "recycling";
export const MACHINE_CATEGORY__AGRICULTURE = "agriculture";
export const MACHINE_CATEGORY__TELECOMMUNICATION = "telecommunication";
export const MACHINE_CATEGORY__OTHER = "other";
export const MACHINE_DESCRIPTION = "machine_description";
export const MACHINE_PERIOD_OF_USE = "machine_period_of_use";
export const MACHINE_KIND = "machine_kind";
export const MACHINE_IS_NEW = "machine_is_new";
export const MACHINE_AGE = "machine_age";
export const MACHINE_ORIGINAL_PRICE = "machine_original_price";
export const MACHINE_IS_ORDERED = "machine_is_ordered";
export const MACHINE_DELIVERY_DATE = "machine_delivery_date";
export const MACHINE_MANUFACTURER = "machine_manufacturer";

/**
 *  Development Expenditure
 */

export const DEVELOPMENT_EXPENDITURE_DESCRIPTION = "development_expenditure_description";

/**
 *  Corona
 */

export const CORONA_TOTAL_REVENUE = "corona_total_revenue";
export const CORONA_PERSONNEL_COSTS = "corona_personnel_costs";
export const CORONA_LIQUIDITY_NEED = "corona_liquidity_need";

/**
 *  Other
 */

export const OTHER_DESCRIPTION = "other_description";
export const FINANCING_DESCRIPTION = "financing_description";

/**
 * Demand
 */

export const FINANCING_OWN_FOUNDS = "financing_own_founds";
export const FINANCING_DEMAND = "financial_demand";

/**
 *  Payment date
 */

export const PAYMENT_DATE = "favored_decision_date";

export const GUARANTEE_SUPPORT = "guarantee_support";
export const EQUITY_SUPPORT = "equity_support";
export const STRUCTURING_SUPPORT = "structuring_support";

export const COLLATERALS = "collaterals";

export const COLLATERALS_KIND = "kind";
export const COLLATERALS_KIND__CESSION_OF_CREDIT_BALANCES = "cession_of_credit_balances";
export const COLLATERALS_KIND__CESSION_OF_LIFE_INSURANCE = "cession_of_life_insurance";
export const COLLATERALS_KIND__CESSION_OF_RECEIVABLES = "cession_of_receivables";
export const COLLATERALS_KIND__FINANCING_OBJECT = "financing_object";
export const COLLATERALS_KIND__GUARANTEE = "guarantee";
export const COLLATERALS_KIND__LAND_CHARGES = "land_charges";
export const COLLATERALS_KIND__LAND_CHARGES_ON_FINANCING_OBJECT =
  "land_charges_on_financing_object";
export const COLLATERALS_KIND__WAREHOUSE_TRANSFER_BY_WAY_OF_SECURITY =
  "warehouse_transfer_by_way_of_security";

export const COLLATERALS_VALUE = "value";

export const COLLATERALS_DESCRIPTION = "description";

/**
 * Bank
 */

export const ALREADY_AT_THE_BANK = "already_at_the_bank";
export const USED_BANKS = "used_banks";

export const BANKS_TO_FORWARD = "banks_to_forward";
export const BANK_SUGGESTIONS = "bank_suggestions";

export const EXCLUDED_BANKS = "excluded_banks";

/**
 * Financing support
 */

export const FINANCING_SUPPORT = "financing_support";

/**
 * Financing product
 */

export const FINANCING_PRODUCT = "product_kind";
export const FINANCING_PRODUCT__CORONA_LOAN = "corona_loan";
export const FINANCING_ASSETS_IN_KIND = "assets_in_kind";
export const FINANCING_PRODUCT__EQUITY = "equity";
export const FINANCING_PRODUCT__EQUITY_FINANCING = "equity_financing";
export const FINANCING_PRODUCT__GUARANTEED_CREDIT = "guaranteed_credit";
export const FINANCING_PRODUCT__HOUSE_BANK_LOAN = "house_bank_loan";
export const FINANCING_PRODUCT__LEASING = "leasing";
export const FINANCING_PRODUCT__LOAN = "loan";
export const FINANCING_PRODUCT__MICRO_MEZZANINE = "micro_mezzanine";
export const FINANCING_PRODUCT__OTHER = "other";
export const FINANCING_PRODUCT__OWN_CONTRIBUTION = "own_contribution";
export const FINANCING_PRODUCT__OVERDRAFT = "overdraft";
export const FINANCING_PRODUCT__PROMOTIONAL_LOAN = "promotional_loan";
export const FINANCING_PRODUCT__RELATIVE_LOAN = "relative_loan";
export const FINANCING_PRODUCT__SILENT_PARTNERSHIP = "silent_partnership";
export const FINANCING_PRODUCT__SUBSIDY = "subsidy";
export const FINANCING_PRODUCT__VENDOR_LOAN = "vendor_loan";
export const FINANCING_PRODUCT__ONGOING_REVENUE_CASHFLOW = "ongoing_revenue_cashflow";
export const FINANCING_PRODUCT__KFW_ERP_FGN_LOAN = "kfw_erp_fgn_loan";

/**
 * Corona Loan
 */

export const CORONA_LOAN_SECTION_ID = "corona_loan_section";

export const CORONA_LOAN_FIXED_INTEREST_RATE = "corona_loan_fixed_interest_rate";
export const CORONA_LOAN_FIXED_INTEREST_RATE__FIXED = true;
export const CORONA_LOAN_FIXED_INTEREST_RATE__VARIABLE = false;

export const CORONA_LOAN_KIND = "corona_loan_kind";
export const CORONA_LOAN_KIND__AMORTISABLE_LOAN = "amortisable_loan";
export const CORONA_LOAN_KIND__ANNUITY_LOAN = "annuity_loan";

export const CORONA_LOAN_INTERESTED_IN_ALTERNATIVE_FINANCING =
  "corona_loan_interested_in_alternative_financing";

export const CORONA_LOAN_INTEREST_PERIOD_IN_MONTHS = "corona_loan_interest_period_in_months";

export const CORONA_LOAN_TERM_IN_MONTHS = "corona_loan_term_in_months";

/**
 * Loan
 */

export const LOAN_FIXED_INTEREST_RATE = "loan_fixed_interest_rate";
export const LOAN_FIXED_INTEREST_RATE__FIXED = true;
export const LOAN_FIXED_INTEREST_RATE__VARIABLE = false;

export const LOAN_KIND = "loan_kind";
export const LOAN_KIND__AMORTISABLE_LOAN = "amortisable_loan";
export const LOAN_KIND__ANNUITY_LOAN = "annuity_loan";
export const LOAN_KIND__LOAN_PAYABLE_AT_TERM = "loan_payable_at_term";

export const LOAN_INTERESTED_IN_ALTERNATIVE_FINANCING = "loan_interested_in_alternative_financing";
export const LOAN_INTEREST_PERIOD_IN_MONTHS = "loan_interest_period_in_months";
export const LOAN_TERM_IN_MONTHS = "loan_term_in_months";

/**
 * Subsidies
 */

export const CONSIDER_SUBSIDIES = "consider_subsidies";

/**
 * Leasing
 */

// export const LEASING_SECTION_ID = "leasing_section";

export const LEASING_AMORTISATION_KIND = "leasing_amortisation_kind";
export const LEASING_AMORTISATION_KIND__PARTIAL_AMORTISATION = "partial_amortisation";
export const LEASING_AMORTISATION_KIND__FULL_AMORTISATION = "full_amortisation";
export const LEASING_AMORTISATION_KIND__HIRE_PURCHASE = "hire_purchase";
export const LEASING_AMORTISATION_KIND__UNDETERMINED = "undetermined";

export const LEASING_RESIDUAL_VALUE = "leasing_residual_value";

export const LEASING_TAKEOVER = "leasing_takeover";
export const LEASING_TAKEOVER__YES = "yes";
export const LEASING_TAKEOVER__NO = "no";
export const LEASING_TAKEOVER__UNDECIDED = "undecided";

export const LEASING_DESCRIPTION = "leasing_description";

export const LEASING_TERM_IN_MONTHS = "leasing_term_in_months";

/**
 * Leasing advisor inquiry
 */

export const CONTRACT_TYPE = "contract_type";
export const CONTRACT_TYPE__LEASING = "leasing";
export const CONTRACT_TYPE__OWN = "rent_to_own";

export const LEASING_CONTRACT_TYPE = "leasing_contract_type";
export const LEASING_CONTRACT_TYPE__PARTIAL = "partial_amortization";
export const LEASING_CONTRACT_TYPE__FULL = "full_amortization";

export const LEASING_RATE = "leasing_rate";
export const LEASING_RATE__CONSTANT = "constant";
export const LEASING_RATE__CHANGEABLE = "changeable";

export const FINANCING_PLAN_SECTION_ID = "financing_plan";
export const FINANCING_PLAN__EXPANSION_INVESTMENT = "expansion_investment";
export const FINANCING_PLAN__REPLACEMENT_INVESTMENT = "replacement_investment";
export const FINANCING_PLAN__COMPANY_EXPANSION = "company_expansion";
export const FINANCING_PLAN__RELOCATION = "relocation";
export const FINANCING_PLAN__BUSINESS_START = "business_start";
export const FINANCING_PLAN__NEW_BRANCH = "new_branch";
export const FINANCING_PLAN__OTHER = "other";

/**
 * Equity, micro-mezzanine other
 */

export const PRODUCT_KIND_DESCRIPTION = "product_description";
export const FINANCING_OWN_IDEA = "financing_own_idea";

export const EQUITY_STRUCTURE = "equity_structure";

export const EQUITY_STRUCTURE__CLASSICAL_MEZZANINE = "classical_mezzanine";
export const EQUITY_STRUCTURE__VENTURE_CAPITAL = "venture_capital";
export const EQUITY_STRUCTURE__DONT_KNOW_YET = "dont_know_yet";

/**
 * Unternehmenswerkstatt (UWD)
 */

export const UWD_CHAMBER = "chamber";
export const UWD_CHAMBER_EXPERT = "chamber_expert";
export const UWD_CHAMBER_PROJECT = "chamber_project";

/**
 * Bank Advisor
 */

export const BANK_CODE = "bank_code";
export const BANK_NAME = "bank_name";
export const GENDER = "gender";
export const EMAIL = "email";
export const PHONE_NUMBER = "phone_number";
export const BANK_ADVISOR = "bank_advisor";
